// pp-cotizaciones.js — pinta «Mis cotizaciones» (/pages/cliente-cotizaciones).
//
// Encargo del Padrino (24-sep-2026): «que puedan ver la cotización, la última
// pactada, hasta qué día está vigente, y que puedan bajarlas desde ahí». Y qué
// es la última pactada: «un draft es una cotización y esa la pueden cambiar;
// los ejecutivos van cambiando de poco en poco, pero queremos que puedan ver el
// último draft».
//
// GET /apps/crm/customer-cotizaciones →
//   { found, dias_de_vigencia, cotizaciones: [{ folio, fecha, actualizada,
//     dias_sin_tocar, total, subtotal, partidas_count, partidas:[{nombre, sku,
//     cantidad, precio_unitario, subtotal}], vigencia_hasta, vigencia_origen,
//     vigente, liga, pedida_por, es_mia }] }
//
// Vienen ordenadas por `actualizada` desc: la primera es LA ÚLTIMA.
//
// TRES COSAS QUE ESTE ARCHIVO NO HACE, A PROPÓSITO:
//
//   1. NO esconde ni apaga una cotización por estar vencida. Medido: de las
//      2,300 que sí se compraron, el 12% se compró DESPUÉS del día 7 con la
//      liga funcionando. La vigencia informa, no bloquea.
//
//   2. NO le dice «descargar» al botón. Esa liga es el checkout del draft con
//      sus partidas, no un PDF. Mandar a alguien a pagar con un botón que dice
//      «descargar» es una trampa.
//
//   3. NO calcula la vigencia. La manda el backend ya resuelta, y también
//      `vigente` — porque el reloj del navegador del cliente puede estar
//      corrido y no vamos a discutirle una fecha por eso.
//
// MONTOS EN PESOS (float), como los manda el backend: formatMoney NO divide
// entre 100 (mismo criterio que pp-company-stats.js).

(function () {
  'use strict';

  var ENDPOINT = '/apps/crm/customer-cotizaciones';

  // Arriba de esto una cotización se considera dormida y se pliega. Empack
  // tiene 22 abiertas y solo 2 recientes: las demás llevan de 83 a 230 días
  // sin tocarse. Sin este corte, la página le vuelca 22 renglones de basura.
  var DIAS_DORMIDA = 90;

  var root = document.querySelector('[data-pp-cotiza]');
  if (!root) return;

  // En el editor del theme no hay sesión de cliente logueado.
  if (window.Shopify && window.Shopify.designMode) return;

  var loadingEl = root.querySelector('[data-pp-cotiza-loading]');
  var ultimaEl = root.querySelector('[data-pp-cotiza-ultima]');
  var listaEl = root.querySelector('[data-pp-cotiza-lista]');
  var dormidasEl = root.querySelector('[data-pp-cotiza-dormidas]');
  var dormidasLabelEl = root.querySelector('[data-pp-cotiza-dormidas-label]');
  var listaDormidasEl = root.querySelector('[data-pp-cotiza-lista-dormidas]');
  var emptyEl = root.querySelector('[data-pp-cotiza-empty]');
  var errorEl = root.querySelector('[data-pp-cotiza-error]');

  function t(key) {
    return root.getAttribute('data-t-' + key) || '';
  }

  function show(el) { if (el) el.hidden = false; }
  function hide(el) { if (el) el.hidden = true; }

  var money = new Intl.NumberFormat('es-MX', {
    style: 'currency', currency: 'MXN', minimumFractionDigits: 0, maximumFractionDigits: 0
  });
  function formatMoney(pesos) {
    var n = typeof pesos === 'number' ? pesos : parseFloat(pesos || 0);
    if (!isFinite(n)) n = 0;
    return money.format(n);
  }

  // Con centavos: el precio por pieza ($0.89/bolsa) y por paquete ($88.55).
  // Redondeado a pesos, «$0.89» saldría «$1» y el cálculo no cuadraría.
  var moneyFino = new Intl.NumberFormat('es-MX', {
    style: 'currency', currency: 'MXN', minimumFractionDigits: 2, maximumFractionDigits: 2
  });
  function formatFino(pesos) {
    var n = Number(pesos);
    return isFinite(n) ? moneyFino.format(n) : '';
  }

  /**
   * Las piezas TOTALES de la cotización, por unidad: «10,000 bolsas · 660
   * etiquetas · 22 cintas», como el encabezado del carrito. Sólo de los
   * renglones que saben cuántas traen.
   */
  function totalesDePiezas(c) {
    var porUnidad = {};
    var orden = [];
    (c.partidas || []).forEach(function (p) {
      var pack = Number(p.piezas_por_paquete);
      if (!(isFinite(pack) && pack > 0 && p.unidad_plural)) return;
      var n = pack * (Number(p.cantidad) || 0);
      if (!(p.unidad_plural in porUnidad)) { porUnidad[p.unidad_plural] = 0; orden.push(p.unidad_plural); }
      porUnidad[p.unidad_plural] += n;
    });
    return orden.map(function (u) { return porUnidad[u].toLocaleString('es-MX') + ' ' + u; });
  }

  function formatFecha(iso) {
    if (!iso) return '';
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    return d.toLocaleDateString('es-MX', { day: 'numeric', month: 'long', year: 'numeric' });
  }

  // Plural con el mismo patrón del resto del portal: Liquid deja el número de
  // la forma singular/plural y aquí se sustituye por el real.
  function plural(one, other, count) {
    var tmpl = count === 1 ? one : other;
    return tmpl.replace(/\d+/, String(count));
  }

  function el(tag, cls, texto) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (texto != null) n.textContent = texto;
    return n;
  }

  /**
   * El renglón de vigencia. Vigente y vencida se distinguen por el TEXTO y por
   * el icono, no solo por el color: quien no distingue rojo de verde tiene que
   * poder leerlo igual.
   */
  function pintarVigencia(c) {
    var caja = el('div', 'pp-cotiza__vigencia' + (c.vigente === false ? ' pp-cotiza__vigencia--vencida' : ''));
    if (!c.vigencia_hasta) return caja;

    var fecha = formatFecha(c.vigencia_hasta);
    if (c.vigente === false) {
      caja.appendChild(el('span', 'pp-cotiza__vigencia-texto', t('vencio').replace('{fecha}', fecha)));
      caja.appendChild(el('span', 'pp-cotiza__vigencia-nota', t('vencio-nota')));
    } else {
      caja.appendChild(el('span', 'pp-cotiza__vigencia-texto', t('vigente-hasta').replace('{fecha}', fecha)));
    }
    return caja;
  }

  /**
   * Los botones. Una cotización VENCIDA conserva su liga — ver la nota 1 de
   * arriba. Cuando está vencida se le suma la salida: pedir que la actualicen.
   * Sin liga no se pinta un botón muerto: se dice qué hacer.
   */
  // Iconos en línea. El portal no carga una fuente de iconos, y un emoji no
  // es un icono: no hereda el color del botón y se ve distinto por sistema.
  function icono(paths) {
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '2');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('class', 'pp-cotiza__icono');
    paths.forEach(function (d) {
      var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('d', d);
      svg.appendChild(path);
    });
    return svg;
  }

  var ICONO_PAGAR = ['M5 12h14', 'M13 6l6 6-6 6'];
  var ICONO_PDF = ['M12 3v12', 'M7 11l5 5 5-5', 'M4 21h16'];
  var ICONO_ACTUALIZAR = ['M20 11a8 8 0 1 0-2.3 5.7', 'M20 5v6h-6'];
  var ICONO_CORREO = ['M4 6h16v12H4z', 'M4 7l8 6 8-6'];
  var ICONO_WHATSAPP = ['M3 21l1.6-4.7A8.5 8.5 0 1 1 7.8 19.6z', 'M9 9.5c.5 2 2.3 4 4.5 4.8l1-1 1.8.8-.4 1.6c-3.6.2-7.2-3.4-7.3-7l1.6-.4.8 1.8z']

  function boton(tag, clase, texto, paths) {
    var n = el(tag, 'pp-section__cta ' + clase);
    if (paths) n.appendChild(icono(paths));
    n.appendChild(document.createTextNode(texto));
    return n;
  }

  /**
   * Los botones. `.pp-section__cta` es el botón REAL del portal y vive en
   * pp-customer-sections.css, que esta página sí carga — la primera versión
   * usaba `.pp-btn`, que vive en pp-static-page.css y aquí NO se carga: por
   * eso salían como links subrayados.
   *
   * Tres pesos: pagar es la acción principal, descargar es la que el cliente
   * grande necesita para su contador, y pedir actualización es la salida
   * cuando ya venció.
   *
   * Una cotización VENCIDA conserva su liga — ver la nota 1 de arriba.
   */
  function pintarAcciones(c, indice) {
    var caja = el('div', 'pp-cotiza__acciones');
    if (c.liga) {
      var a = boton('a', 'pp-cotiza__cta', t('ver-pagar'), ICONO_PAGAR);
      a.href = c.liga;
      // La liga es de Shopify, fuera del portal: otra pestaña para no
      // tragarse la navegación del cliente (misma razón que Direcciones).
      a.target = '_blank';
      a.rel = 'noopener';
      caja.appendChild(a);
    }

    // Descargar: «yo soy grande y tengo que mandarlo a mis contadores»
    // (Padrino, 25-sep-2026).
    //
    // Desde el 26-sep-2026 baja un PDF DE VERDAD, con su nombre
    // (Cotizacion-D12345.pdf), texto seleccionable y paginado — lo genera
    // pp-cotizacion-pdf.js con el MISMO formato que el PDF que el equipo
    // manda desde el CRM. La librería se carga SOLO al picar este botón: hasta
    // entonces cuesta cero bytes, que es lo que hacía cierta la nota vieja de
    // «una librería pesaría más que toda la página».
    //
    // Si la librería no carga (red, bloqueador), NO se deja al cliente sin
    // salida: cae a imprimirSolo(), que es lo que hacía antes y sigue vivo.
    var pdf = boton('button', 'pp-section__cta--pdf pp-cotiza__cta', t('descargar'), ICONO_PDF);
    pdf.type = 'button';
    pdf.addEventListener('click', function () {
      var motor = window.PPCotizacionPDF;
      // Sin motor: el PDF hecho en el SERVIDOR (13-oct-2026), y si tampoco,
      // imprimir — la salida de siempre.
      if (!motor || !motor.listo()) { pdfDelServidor(c, indice); return; }

      // El botón dice que está trabajando: generar tarda un momento la primera
      // vez (la librería viaja en ese clic) y un botón que no responde se pica
      // dos veces.
      if (pdf.disabled) return;
      pdf.disabled = true;
      pdf.classList.add('is-cargando');
      motor.descargar(c)
        .catch(function () { return pdfDelServidor(c, indice); })
        .then(function () {
          pdf.disabled = false;
          pdf.classList.remove('is-cargando');
        });
    });
    caja.appendChild(pdf);

    // Compartir: por correo (lo manda el backend, necesita el draft) y por
    // WhatsApp, en su verde (Padrino, 30-sep-2026). El que arma la cotización
    // casi nunca es el que la autoriza.
    if (window.PPCompartirCotizacion) {
      if (c.draft_id) {
        var correo = boton('button', 'pp-section__cta--ghost pp-cotiza__cta', t('enviar-correo'), ICONO_CORREO);
        correo.type = 'button';
        correo.addEventListener('click', function () {
          window.PPCompartirCotizacion.abrir({ modo: 'correo', draftId: c.draft_id, cotizacion: c });
        });
        caja.appendChild(correo);
      }
      var wa = boton('button', 'pp-section__cta--whatsapp pp-cotiza__cta', t('enviar-whatsapp'), ICONO_WHATSAPP);
      wa.type = 'button';
      wa.addEventListener('click', function () {
        window.PPCompartirCotizacion.abrir({ modo: 'whatsapp', draftId: c.draft_id, cotizacion: c });
      });
      caja.appendChild(wa);
    }

    if (c.vigente === false) {
      var b = boton('a', 'pp-section__cta--ghost pp-cotiza__cta', t('actualizar'), ICONO_ACTUALIZAR);
      b.href = '/pages/cliente-soporte';
      caja.appendChild(b);
    }
    if (!c.liga) {
      caja.appendChild(el('p', 'pp-cotiza__sin-liga', t('sin-liga')));
    }
    return caja;
  }

  /**
   * Imprime UNA cotización, no la página entera.
   *
   * Se marca la tarjeta elegida y el CSS de impresión esconde todo lo demás
   * (@media print). La marca se quita en cuanto la ventana de impresión se
   * cierra: si se quedara puesta, la siguiente impresión sacaría dos.
   */
  /**
   * El respaldo de «Descargar»: el MISMO PDF, hecho en el servidor y bajado
   * por una liga firmada (pp-cotizacion-nucleo.js). Sólo entra cuando el motor
   * de aquí no pudo —la librería no cargó, un bloqueador—; si el servidor
   * tampoco puede, queda imprimir, que nunca falla.
   */
  function pdfDelServidor(c, indice) {
    var N = window.PPCotizacionNucleo;
    if (!c || !c.draft_id || !N || !N.pdfServidor) { imprimirSolo(indice); return Promise.resolve(); }
    return N.pdfServidor(c.draft_id).then(function (r) {
      if (!r || !r.ok || !N.bajar(r.url)) imprimirSolo(indice);
    }, function () { imprimirSolo(indice); });
  }

  function imprimirSolo(indice) {
    var tarjetas = root.querySelectorAll('[data-pp-cotiza-card]');
    for (var i = 0; i < tarjetas.length; i++) {
      tarjetas[i].classList.toggle('pp-cotiza--imprimiendo', String(i) === String(indice));
    }
    root.classList.add('pp-cotiza--modo-impresion');
    var limpiar = function () {
      root.classList.remove('pp-cotiza--modo-impresion');
      for (var j = 0; j < tarjetas.length; j++) {
        tarjetas[j].classList.remove('pp-cotiza--imprimiendo');
      }
      window.removeEventListener('afterprint', limpiar);
    };
    window.addEventListener('afterprint', limpiar);
    window.print();
    // Safari no siempre dispara afterprint. Red de seguridad para que la
    // marca no se quede pegada y la siguiente impresión saque dos tarjetas.
    setTimeout(limpiar, 1500);
  }

  // Sin foto: un icono en el MISMO marco, no un hueco. El servicio de
  // personalización (SKU IUV-*) no tiene foto en el catálogo — medido el
  // 30-sep-2026: products.image_url es null para IUV-001 — y un cuadro vacío
  // se leía como «imagen rota» (Padrino: «hay que ponerle algo»).
  var ICONO_PERSONALIZAR = ['M9.06 11.9l8.07-8.06a2.85 2.85 0 1 1 4.03 4.03l-8.06 8.08', 'M7.07 14.94c-1.66 0-3 1.35-3 3.02 0 1.33-2.5 1.52-2 2.02 1.08 1.1 2.49 2.02 4 2.02 2.2 0 4-1.8 4-4.04a3.01 3.01 0 0 0-3-3.02z'];
  var ICONO_PRODUCTO = ['M21 8l-9-5-9 5 9 5 9-5z', 'M3 8v8l9 5 9-5V8', 'M12 13v8'];

  function esPersonalizacion(p) {
    return /^IUV/i.test(String(p.sku || ''));
  }

  /**
   * Lo que incluye la cotización — SIEMPRE A LA VISTA (Padrino, 30-sep-2026:
   * «quítame el ver qué incluye; que desde ahí puedan ver todo»). Antes vivía
   * detrás de un <details>, y quien abría la página veía un total sin saber de
   * qué.
   *
   * Cada renglón se lee como en el carrito: precio por pieza y, cuando hay
   * descuento, el de lista TACHADO con su porcentaje. `precio_lista` sólo
   * llega cuando difiere del que se cobra (backend), así que un tachado igual
   * al precio no puede salir.
   */
  function pintarPartidas(c) {
    if (!c.partidas || !c.partidas.length) return null;
    var caja = el('div', 'pp-cotiza__partidas');

    var ul = el('ul', 'pp-cotiza__partidas-lista');
    ul.setAttribute('role', 'list');
    c.partidas.forEach(function (p) {
      var li = el('li', 'pp-cotiza__partida');

      // La foto, en un marco BLANCO igual para todas. Antes el marco era beige
      // y las fotos con fondo transparente (el cacahuate) lo dejaban ver: una
      // miniatura salía de otro color que las demás.
      var foto = el('span', 'pp-cotiza__partida-foto');
      if (p.imagen) {
        var img = document.createElement('img');
        img.src = p.imagen;
        img.alt = '';
        img.loading = 'lazy';
        img.width = 56;
        img.height = 56;
        foto.appendChild(img);
      } else {
        foto.classList.add('pp-cotiza__partida-foto--vacia');
        foto.appendChild(icono(esPersonalizacion(p) ? ICONO_PERSONALIZAR : ICONO_PRODUCTO));
      }
      li.appendChild(foto);

      // COMO EL CARRITO (Padrino, 30-sep-2026: «son 100 piezas o 100
      // paquetes? … me gusta cómo lo tenemos en el carrito»):
      //   SKU PB-1111 | 100 BOLSAS | $0.89/bolsa
      //   $88.55 c/paquete  ~~$115~~  -23%
      // y a la derecha el total tachado, el real y «× 10,000 bolsas». Las
      // piezas por paquete las manda el backend del metacampo custom.unidades
      // (el mismo que lee el carrito); sin el dato, se dice lo que se sabe.
      var pack = Number(p.piezas_por_paquete);
      var tienePack = isFinite(pack) && pack > 0 && !!p.unidad_singular;
      var esPaquete = tienePack && pack > 1;
      var cantidad = Number(p.cantidad) || 0;
      var pu = Number(p.precio_unitario);
      var pl = Number(p.precio_lista);
      var conDescuento = isFinite(pl) && isFinite(pu) && pl > pu;

      var texto = el('span', 'pp-cotiza__partida-texto');
      texto.appendChild(el('span', 'pp-cotiza__partida-nombre', p.nombre || '—'));

      var meta = [];
      if (p.sku) meta.push('SKU ' + p.sku);
      if (tienePack) meta.push(pack.toLocaleString('es-MX') + ' ' + (pack === 1 ? p.unidad_singular : p.unidad_plural));
      if (esPaquete && isFinite(pu) && pu > 0) meta.push(formatFino(pu / pack) + '/' + p.unidad_singular);
      if (meta.length) texto.appendChild(el('span', 'pp-cotiza__partida-sku', meta.join('  |  ')));

      if (isFinite(pu) && pu > 0) {
        var precio = el('span', 'pp-cotiza__partida-precio');
        precio.appendChild(el('span', 'pp-cotiza__partida-unitario',
          formatFino(pu) + ' ' + (esPaquete ? t('c-paquete') : t('c-u'))));
        // El descuento por volumen VA EN EL PRECIO, como en el carrito: el de
        // lista tachado y el porcentaje. Antes iba en un renglón aparte abajo
        // («no debería estar abajo»).
        if (conDescuento) {
          precio.appendChild(el('s', 'pp-cotiza__partida-lista', formatFino(pl)));
          precio.appendChild(el('span', 'pp-cotiza__partida-pct', '−' + Math.round((1 - pu / pl) * 100) + '%'));
        }
        texto.appendChild(precio);
      }
      li.appendChild(texto);

      // Cantidad: paquetes cuando es paquete; si no, la unidad misma («10 cintas»).
      var cant;
      if (esPaquete) cant = plural(t('paquetes-one'), t('paquetes-other'), cantidad);
      else if (tienePack) cant = cantidad.toLocaleString('es-MX') + ' ' + (cantidad === 1 ? p.unidad_singular : p.unidad_plural);
      else cant = t('cantidad').replace('{n}', String(cantidad));
      li.appendChild(el('span', 'pp-cotiza__partida-cant', cant));

      var monto = el('span', 'pp-cotiza__partida-monto');
      if (conDescuento) monto.appendChild(el('s', 'pp-cotiza__partida-monto-lista', formatMoney(pl * cantidad)));
      monto.appendChild(el('span', 'pp-cotiza__partida-monto-real', formatMoney(p.subtotal)));
      if (esPaquete) {
        monto.appendChild(el('span', 'pp-cotiza__partida-piezas',
          '× ' + (pack * cantidad).toLocaleString('es-MX') + ' ' + p.unidad_plural));
      }
      li.appendChild(monto);
      ul.appendChild(li);
    });
    caja.appendChild(ul);
    return caja;
  }

  /**
   * El desglose: subtotal, envío e IVA.
   *
   * ⚠️ EL IVA VA ETIQUETADO «incluido» Y NO ES OPCIONAL. El backend manda
   * `iva_incluido` y es true en las 2,595 cotizaciones abiertas recientes:
   * subtotal + envío = total, sin sumarlo. Puesto entre los otros renglones
   * sin esa palabra, quien lo lea va a querer sumarlo. Misma ley que el
   * resumen del detalle de orden.
   */
  function pintarDesglose(c) {
    var d = c.desglose;
    if (!d) return null;
    var caja = el('div', 'pp-cotiza__desglose');

    var fila = function (etiqueta, valor, clase) {
      var f = el('div', 'pp-cotiza__desglose-fila' + (clase ? ' ' + clase : ''));
      f.appendChild(el('span', null, etiqueta));
      f.appendChild(el('span', 'pp-cotiza__desglose-monto', valor));
      return f;
    };

    // COMO EL RESUMEN DEL CARRITO (Padrino, 30-sep-2026): el subtotal con el
    // precio de lista TACHADO, el descuento en su renglón, y el total. El
    // subtotal de Shopify ya trae el descuento aplicado (#D99638: lista
    // $19,083 − $3,554.42 = $15,528.58), así que lo tachado es lista =
    // subtotal + descuento y la resta cuadra con el total. El monto del
    // descuento lo suma el backend (desglose.descuento).
    var conDescuento = d.descuento > 0;
    var sub = el('div', 'pp-cotiza__desglose-fila');
    sub.appendChild(el('span', null, t('subtotal')));
    sub.appendChild(el(conDescuento ? 's' : 'span', 'pp-cotiza__desglose-monto' + (conDescuento ? ' pp-cotiza__desglose-monto--tachado' : ''),
      formatMoney(conDescuento ? (Number(d.subtotal) || 0) + Number(d.descuento) : d.subtotal)));
    caja.appendChild(sub);
    if (conDescuento) {
      caja.appendChild(fila(t('descuento'), '−' + formatMoney(d.descuento), 'pp-cotiza__desglose-fila--descuento'));
    }

    // Envío en $0 son DOS cosas opuestas, y el título es lo que las separa.
    // CON título («Promo Local PP Trucks») es gratis de verdad; SIN título es
    // que la cotización no trae envío. Antes las dos decían «Gratis», y a
    // quien no lo trae se le prometía un envío que no está pagado. Medido el
    // 30-sep-2026 sobre las 1,396 abiertas de 90 días: 400 gratis y 79 sin
    // envío.
    caja.appendChild(fila(
      d.envio_titulo ? t('envio') + ' · ' + d.envio_titulo : t('envio'),
      d.envio > 0 ? formatMoney(d.envio) : (sinEnvio(d) ? t('sin-envio') : t('envio-gratis')),
      sinEnvio(d) ? 'pp-cotiza__desglose-fila--sin-envio' : null
    ));

    // IVA APARTE sólo si NO viene incluido; entonces sí suma y va antes del
    // total. Cuando viene incluido (las 2,595 abiertas recientes) no es un
    // renglón que se suma: se dice junto al total y en la nota de abajo.
    if (d.iva > 0 && !d.iva_incluido) {
      caja.appendChild(fila(t('iva'), formatMoney(d.iva), 'pp-cotiza__desglose-fila--iva'));
    }

    var total = el('div', 'pp-cotiza__desglose-fila pp-cotiza__desglose-fila--total');
    var etiqueta = el('span', 'pp-cotiza__desglose-total-label', t('total'));
    if (d.iva_incluido) etiqueta.appendChild(el('span', 'pp-cotiza__desglose-iva', t('iva-incluido')));
    total.appendChild(etiqueta);
    total.appendChild(el('span', 'pp-cotiza__desglose-monto', formatMoney(d.total)));
    caja.appendChild(total);

    if (d.iva_incluido) {
      caja.appendChild(el('p', 'pp-cotiza__desglose-nota',
        t('iva-nota').replace('{iva}', formatMoney(d.iva))));
    }
    return caja;
  }

  /** Sin envío = $0 Y sin título. Con título, $0 es envío gratis. */
  function sinEnvio(d) {
    return !!d && !(d.envio > 0) && !d.envio_titulo;
  }

  /**
   * El aviso de que no trae envío («Oye, no tiene envío» — Padrino,
   * 29-sep-2026). Dice QUÉ HACER, no sólo qué falta: el envío se escoge y se
   * paga en la pantalla de pago. Va con icono y texto, no sólo color.
   */
  function pintarAvisoSinEnvio(c) {
    if (!sinEnvio(c.desglose)) return null;
    var caja = el('div', 'pp-cotiza__sin-envio');
    caja.setAttribute('role', 'note');
    caja.appendChild(icono(['M12 9v4', 'M12 17h.01', 'M10.3 3.9L1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z']));
    var texto = el('div', 'pp-cotiza__sin-envio-texto');
    texto.appendChild(el('strong', null, t('sin-envio-titulo')));
    texto.appendChild(el('span', null, t('sin-envio-texto')));
    // El aviso trae la SALIDA (Padrino, 30-sep-2026): ver las paqueterías de
    // esta cotización y agregar una. Sin draft_id no hay a qué agregarla.
    if (c.draft_id) {
      var ver = boton('button', 'pp-section__cta--ghost pp-cotiza__envio-ver', t('envio-ver'), ICONO_ENVIO);
      ver.type = 'button';
      ver.addEventListener('click', function () {
        abrirEnvio(c, ver.closest('[data-pp-cotiza-card]'));
      });
      texto.appendChild(ver);
    }
    caja.appendChild(texto);
    return caja;
  }

  // ── El envío de una cotización que ya existe ───────────────────────────────
  //
  // El MISMO modal que el del carrito (Padrino, 30-sep-2026: «lo tengamos de la
  // misma manera»): paqueterías a la izquierda con su propio scroll; a la
  // derecha el total que quedaría y los botones.
  //
  // ⚠️ NINGUNA VIENE PRESELECCIONADA. El 29-sep «la más barata» resultó ser
  // «Enviar guía propia · $0», que no es un envío: «$0» significa cosas
  // opuestas y no se adivina. «Agregar» se prende cuando el cliente escoge.
  //
  // Sólo viaja el HANDLE: el backend busca el precio en la lista viva.
  var ICONO_ENVIO = ['M1 3h15v13H1z', 'M16 8h4l3 3v5h-7V8z', 'M5.5 18.5a2.5 2.5 0 1 0 0-.01', 'M18.5 18.5a2.5 2.5 0 1 0 0-.01'];
  var modal = root.querySelector('[data-pp-cotiza-envio]');
  var envio = { c: null, card: null, precios: {} };

  function enModal(sel) { return modal ? modal.querySelector(sel) : null; }

  function abrirEnvio(c, card) {
    if (!modal) return;
    envio.c = c;
    envio.card = card;
    envio.precios = {};
    var titulo = enModal('[data-pp-cotiza-envio-titulo]');
    if (titulo) titulo.textContent = t('envio-titulo').replace('{folio}', c.folio || '');
    show(enModal('[data-pp-cotiza-envio-cuerpo]'));
    hide(enModal('[data-pp-cotiza-envio-listo]'));
    hide(enModal('[data-pp-cotiza-envio-error]'));
    hide(enModal('[data-pp-cotiza-envio-total]'));
    hide(enModal('[data-pp-cotiza-envio-vacio]'));
    hide(enModal('[data-pp-cotiza-envio-destino-caja]'));
    show(enModal('[data-pp-cotiza-envio-cargando]'));
    hide(enModal('[data-pp-cotiza-envio-actual]'));
    hide(enModal('[data-pp-cotiza-envio-quitar]'));
    show(enModal('[data-pp-cotiza-envio-agregar]'));
    modal.classList.remove('is-listo');
    var lista = enModal('[data-pp-cotiza-envio-tarifas]');
    if (lista) lista.textContent = '';
    var agregar = enModal('[data-pp-cotiza-envio-agregar]');
    if (agregar) agregar.disabled = true;
    var alPagar = enModal('[data-pp-cotiza-envio-al-pagar]');
    if (alPagar) {
      if (c.liga) { alPagar.href = c.liga; show(alPagar); } else { hide(alPagar); }
    }
    if (typeof modal.showModal === 'function') modal.showModal();
    else modal.setAttribute('open', '');
    document.documentElement.classList.add('pp-modal-abierto');

    fetch(ENDPOINT, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ accion: 'tarifas_cotizacion', draft_id: c.draft_id })
    })
      .then(function (r) { return r.json().catch(function () { return null; }); })
      .then(pintarTarifasDeEnvio)
      .catch(function () { pintarTarifasDeEnvio(null); });
  }

  function vacioDeEnvio(texto) {
    var vacio = enModal('[data-pp-cotiza-envio-vacio]');
    if (vacio) { vacio.textContent = texto; show(vacio); }
  }

  function pintarTarifasDeEnvio(b) {
    hide(enModal('[data-pp-cotiza-envio-cargando]'));
    if (!b || !b.ok) {
      // «Ya tiene envío» llega con la cotización VIVA: la tarjeta pudo estar
      // pintando el espejo atrasado. Se corrige ahí mismo, no se queda diciendo
      // «Sin envío» mientras el modal dice lo contrario.
      if (b && b.cotizacion && envio.c) {
        aplicarCotizacion(envio.c, b.cotizacion);
        repintar(envio.card, envio.c);
        recordar(envio.c);
      }
      hide(enModal('[data-pp-cotiza-envio-agregar]'));
      vacioDeEnvio(b && b.error === 'ya_tiene_envio' ? t('envio-ya-tiene') : t('envio-error'));
      return;
    }
    // El envío que el cliente ya puso: se dice cuál es y se ofrece quitarlo.
    var actual = enModal('[data-pp-cotiza-envio-actual]');
    if (actual && b.actual) {
      actual.textContent = t('envio-actual').replace('{envio}',
        b.actual.titulo + (b.actual.precio > 0 ? ' · ' + formatMoney(b.actual.precio) : ''));
      show(actual);
      show(enModal('[data-pp-cotiza-envio-quitar]'));
    }
    if (b.direccion) {
      var destino = enModal('[data-pp-cotiza-envio-destino]');
      if (destino) destino.textContent = [b.direccion.linea, b.direccion.ciudad, b.direccion.cp].filter(Boolean).join(', ');
      show(enModal('[data-pp-cotiza-envio-destino-caja]'));
    }
    var tarifas = b.tarifas || [];
    if (!tarifas.length) {
      vacioDeEnvio(b.motivo === 'sin_direccion' ? t('envio-sin-direccion') : t('envio-sin-tarifas'));
      return;
    }
    var lista = enModal('[data-pp-cotiza-envio-tarifas]');
    tarifas.forEach(function (tf) {
      envio.precios[tf.handle] = Number(tf.precio) || 0;
      var fila = el('label', 'pp-cotizar__tarifa');
      var radio = document.createElement('input');
      radio.type = 'radio';
      radio.name = 'pp_cotiza_envio';
      radio.value = tf.handle;
      radio.addEventListener('change', alEscogerEnvio);
      fila.appendChild(radio);
      fila.appendChild(el('span', 'pp-cotizar__tarifa-nombre', tf.titulo));
      fila.appendChild(el('span', 'pp-cotizar__tarifa-precio',
        Number(tf.precio) > 0 ? formatMoney(tf.precio) : t('envio-gratis')));
      lista.appendChild(fila);
    });
  }

  function envioEscogido() {
    var marcado = modal && modal.querySelector('input[name="pp_cotiza_envio"]:checked');
    return marcado ? marcado.value : '';
  }

  function alEscogerEnvio() {
    var handle = envioEscogido();
    var agregar = enModal('[data-pp-cotiza-envio-agregar]');
    if (agregar) agregar.disabled = !handle;
    var total = enModal('[data-pp-cotiza-envio-total]');
    if (total && handle) {
      // «aprox.»: el total de verdad lo calcula Shopify al agregarlo.
      total.textContent = t('envio-nuevo-total')
        .replace('{total}', formatMoney((Number(envio.c && envio.c.total) || 0) + envio.precios[handle]));
      show(total);
    }
  }

  /**
   * EL ESPEJO TARDA 161 s, Y RECARGAR NO PUEDE DESHACER LO QUE SÍ PASÓ.
   *
   * El 30-sep el Padrino agregó el envío, recargó, y la tarjeta volvió a decir
   * «Sin envío» mientras Shopify ya lo tenía. Se guarda en ESTE navegador lo
   * que devolvió Shopify y se pinta encima del espejo hasta que el espejo traiga
   * una versión más nueva (o pasen 15 minutos). Es una comodidad de quien lo
   * hizo: los demás lo ven cuando llega el espejo.
   */
  var RECUERDO = 'pp-cotiza-envio:';
  var MINUTOS_RECUERDO = 15;

  function recordar(c) {
    if (!c.draft_id) return;
    try {
      window.localStorage.setItem(RECUERDO + c.draft_id, JSON.stringify({
        at: Date.now(), total: c.total, desglose: c.desglose, entrega: c.entrega,
        envio_del_cliente: c.envio_del_cliente
      }));
    } catch (e) { /* sin almacenamiento: queda lo del espejo */ }
  }

  function aplicarRecuerdo(c) {
    if (!c || !c.draft_id) return c;
    try {
      var clave = RECUERDO + c.draft_id;
      var r = JSON.parse(window.localStorage.getItem(clave) || 'null');
      if (!r) return c;
      var vencido = Date.now() - r.at > MINUTOS_RECUERDO * 60000;
      var alcanzado = (Date.parse(c.actualizada || '') || 0) >= r.at;
      if (vencido || alcanzado) { window.localStorage.removeItem(clave); return c; }
      c.total = r.total;
      c.desglose = r.desglose;
      if (r.entrega) c.entrega = r.entrega;
      c.envio_del_cliente = r.envio_del_cliente;
    } catch (e) { /* recuerdo ilegible: queda lo del espejo */ }
    return c;
  }

  /** Lo que devolvió Shopify, sobre la cotización que se pinta. */
  function aplicarCotizacion(c, cot) {
    if (!cot) return;
    c.total = cot.total;
    c.desglose = Object.assign({}, c.desglose || {}, cot.desglose || {});
    if (!c.entrega && cot.entrega) c.entrega = cot.entrega;
  }

  /** Vuelve a pintar UNA tarjeta con la cotización ya actualizada. */
  function repintar(card, c) {
    if (!card) return;
    var indice = card.getAttribute('data-pp-cotiza-card');
    card.textContent = '';
    pintarCuerpo(card, c, indice, card === ultimaEl);
  }

  function agregarEnvio() {
    var agregar = enModal('[data-pp-cotiza-envio-agregar]');
    var handle = envioEscogido();
    if (!agregar || agregar.disabled || !handle || !envio.c) return;
    agregar.disabled = true;
    agregar.classList.add('is-cargando');
    hide(enModal('[data-pp-cotiza-envio-error]'));
    var c = envio.c;
    fetch(ENDPOINT, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ accion: 'envio_cotizacion', draft_id: c.draft_id, shipping_handle: handle })
    })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (b) { return { status: r.status, b: b }; });
      })
      .then(function (res) {
        if (res.status !== 200 || !res.b || !res.b.ok || !res.b.cotizacion) throw res;
        // Se pinta con lo que devolvió Shopify, NO se relee la lista: el espejo
        // tarda 161 s de mediana y todavía diría «Sin envío». Y se RECUERDA,
        // para que recargar no lo deshaga.
        aplicarCotizacion(c, res.b.cotizacion);
        c.envio_del_cliente = true;
        repintar(envio.card, c);
        recordar(c);
        var d = c.desglose;
        var texto = enModal('[data-pp-cotiza-envio-listo-texto]');
        if (texto) {
          texto.textContent = t('envio-listo')
            .replace('{folio}', c.folio || '')
            .replace('{envio}', (d.envio_titulo || '') + (d.envio > 0 ? ' · ' + formatMoney(d.envio) : ''))
            .replace('{total}', formatMoney(c.total));
        }
        mostrarListoEnvio();
      })
      .catch(function (e) {
        var error = enModal('[data-pp-cotiza-envio-error]');
        if (error) {
          error.textContent = e && e.b && e.b.error === 'ya_tiene_envio' ? t('envio-ya-tiene') : t('envio-error');
          show(error);
        }
        agregar.disabled = false;
      })
      .then(function () { agregar.classList.remove('is-cargando'); });
  }

  function mostrarListoEnvio() {
    hide(enModal('[data-pp-cotiza-envio-cuerpo]'));
    show(enModal('[data-pp-cotiza-envio-listo]'));
    modal.classList.add('is-listo');
  }

  /** Quita el envío que el mismo cliente puso. */
  function quitarEnvio() {
    var quitar = enModal('[data-pp-cotiza-envio-quitar]');
    if (!quitar || quitar.disabled || !envio.c) return;
    quitar.disabled = true;
    hide(enModal('[data-pp-cotiza-envio-error]'));
    var c = envio.c;
    fetch(ENDPOINT, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ accion: 'envio_cotizacion', draft_id: c.draft_id, quitar: true })
    })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (b) { return { status: r.status, b: b }; });
      })
      .then(function (res) {
        if (res.status !== 200 || !res.b || !res.b.ok || !res.b.cotizacion) throw res;
        aplicarCotizacion(c, res.b.cotizacion);
        c.envio_del_cliente = false;
        repintar(envio.card, c);
        recordar(c);
        var texto = enModal('[data-pp-cotiza-envio-listo-texto]');
        if (texto) {
          texto.textContent = t('envio-quitado').replace('{folio}', c.folio || '').replace('{total}', formatMoney(c.total));
        }
        mostrarListoEnvio();
      })
      .catch(function () {
        var error = enModal('[data-pp-cotiza-envio-error]');
        if (error) { error.textContent = t('envio-no-quitado'); show(error); }
      })
      .then(function () { quitar.disabled = false; });
  }

  /** El PDF desde la confirmación: la cotización ya trae el envío nuevo. */
  function pdfDesdeListo() {
    var motor = window.PPCotizacionPDF;
    if (!envio.c || !motor || !motor.listo()) return;
    motor.descargar(envio.c)['catch'](function () { /* el navegador ya avisa */ });
  }

  if (modal) {
    var btnQuitar = enModal('[data-pp-cotiza-envio-quitar]');
    if (btnQuitar) btnQuitar.addEventListener('click', quitarEnvio);
    var btnPdfListo = enModal('[data-pp-cotiza-envio-pdf]');
    if (btnPdfListo) btnPdfListo.addEventListener('click', pdfDesdeListo);
    var btnAgregar = enModal('[data-pp-cotiza-envio-agregar]');
    if (btnAgregar) btnAgregar.addEventListener('click', agregarEnvio);
    Array.prototype.forEach.call(modal.querySelectorAll('[data-pp-cotiza-envio-cerrar]'), function (b) {
      b.addEventListener('click', function () {
        if (typeof modal.close === 'function') modal.close(); else modal.removeAttribute('open');
      });
    });
    // Esc, la X, «Cancelar», «Cerrar» y el fondo sueltan la página aquí.
    modal.addEventListener('close', function () {
      document.documentElement.classList.remove('pp-modal-abierto');
    });
    modal.addEventListener('click', function (e) {
      if (e.target === modal && typeof modal.close === 'function') modal.close();
    });
  }

  /** A dónde se entrega. Solo se pinta si el backend mandó dirección. */
  function pintarEntrega(c) {
    if (!c.entrega) return null;
    var e = c.entrega;
    var caja = el('div', 'pp-cotiza__entrega');
    caja.appendChild(el('span', 'pp-cotiza__entrega-label', t('entrega')));
    var cuerpo = el('span', 'pp-cotiza__entrega-cuerpo');
    if (e.nombre) cuerpo.appendChild(el('span', 'pp-cotiza__entrega-nombre', e.nombre));
    var partes = [e.linea, e.ciudad, e.estado, e.cp].filter(Boolean);
    if (partes.length) cuerpo.appendChild(el('span', null, partes.join(', ')));
    caja.appendChild(cuerpo);
    return caja;
  }

  function pintarMeta(c) {
    var meta = el('div', 'pp-cotiza__meta');
    var partes = [];
    if (c.fecha) partes.push(formatFecha(c.fecha));
    if (c.partidas_count) {
      partes.push(plural(t('partidas-one'), t('partidas-other'), c.partidas_count));
    }
    // Quién la pidió solo aporta cuando NO fue quien está viendo la página:
    // decirle "pedida por ti" es ruido.
    if (c.pedida_por && c.es_mia === false) {
      partes.push(t('pedida-por').replace('{nombre}', c.pedida_por));
    }
    meta.textContent = partes.join(' · ');
    return meta;
  }

  function pintarPiezas(c) {
    var totales = totalesDePiezas(c);
    return totales.length ? el('div', 'pp-cotiza__piezas', totales.join('  ·  ')) : null;
  }

  /**
   * El cuerpo de una cotización. Es el MISMO para la destacada y para las de
   * la lista: si fueran dos armados distintos, cualquier cosa que se agregue
   * después —como pasó con el desglose y la entrega— habría que acordarse de
   * ponerla en los dos, y un día alguien no se acuerda.
   *
   * `indice` es la posición en la página, y es lo que deja imprimir SOLO ésta.
   */
  function pintarCuerpo(caja, c, indice, destacada) {
    caja.setAttribute('data-pp-cotiza-card', String(indice));

    if (destacada) caja.appendChild(el('div', 'pp-cotiza__eyebrow', t('ultima')));

    var head = el('div', 'pp-cotiza__head');
    var izq = el('div', 'pp-cotiza__head-izq');
    izq.appendChild(el(destacada ? 'h2' : 'span', 'pp-cotiza__folio', c.folio || t('folio')));
    izq.appendChild(pintarMeta(c));
    var piezas = pintarPiezas(c);
    if (piezas) izq.appendChild(piezas);
    head.appendChild(izq);
    // El total NO se repite en el encabezado (Padrino, 30-sep-2026: «vamos
    // varias veces con el precio total»): vive en el desglose, junto a su IVA.
    caja.appendChild(head);

    // DOS COLUMNAS, como el resumen del carrito: lo que se cotizó a la
    // izquierda y el dinero a la derecha, en una columna angosta con sus
    // botones debajo. En una sola columna el desglose se estiraba a todo el
    // ancho con los montos en la orilla — «hay mucho espacio muerto»
    // (Padrino, 29-sep-2026). En celular el CSS las apila.
    var cols = el('div', 'pp-cotiza__cols');
    var izq = el('div', 'pp-cotiza__izq');
    var der = el('div', 'pp-cotiza__der');

    izq.appendChild(pintarVigencia(c));

    var entrega = pintarEntrega(c);
    if (entrega) izq.appendChild(entrega);

    var partidas = pintarPartidas(c);
    if (partidas) izq.appendChild(partidas);

    var desglose = pintarDesglose(c);
    if (desglose) der.appendChild(desglose);

    // La nota del ejecutivo va A LA DERECHA, junto al dinero (Padrino,
    // 30-sep-2026): casi siempre habla del precio o de la entrega, y abajo de
    // la lista de productos se perdía.
    if (c.nota) {
      var nota = el('p', 'pp-cotiza__nota');
      nota.appendChild(el('span', 'pp-cotiza__nota-label', t('nota')));
      nota.appendChild(document.createTextNode(c.nota));
      der.appendChild(nota);
    }

    var aviso = pintarAvisoSinEnvio(c);
    if (aviso) der.appendChild(aviso);

    // El envío que puso EL CLIENTE se cambia o se quita desde aquí; el de un
    // ejecutivo no (el backend tampoco lo deja).
    if (c.draft_id && c.envio_del_cliente && !sinEnvio(c.desglose)) {
      var cambiar = boton('button', 'pp-section__cta--ghost pp-cotiza__envio-ver', t('envio-cambiar-o-quitar'), ICONO_ENVIO);
      cambiar.type = 'button';
      cambiar.addEventListener('click', function () {
        abrirEnvio(c, cambiar.closest('[data-pp-cotiza-card]'));
      });
      der.appendChild(cambiar);
    }

    der.appendChild(pintarAcciones(c, indice));

    cols.appendChild(izq);
    cols.appendChild(der);
    caja.appendChild(cols);
  }

  /** La destacada: la última. */
  function pintarDestacada(c) {
    ultimaEl.textContent = '';
    pintarCuerpo(ultimaEl, c, 0, true);
    show(ultimaEl);
  }

  /** Un renglón de lista. */
  function pintarRenglon(c, indice) {
    var li = el('li', 'pp-cotiza__item');
    pintarCuerpo(li, c, indice, false);
    return li;
  }

  function render(data) {
    var lista = (data && Array.isArray(data.cotizaciones)) ? data.cotizaciones : [];
    lista = lista.map(aplicarRecuerdo);
    hide(loadingEl);

    if (!lista.length) {
      show(emptyEl);
      return;
    }

    // El backend ya las manda por `actualizada` desc.
    pintarDestacada(lista[0]);

    var resto = lista.slice(1);
    var vivas = resto.filter(function (c) {
      return c.dias_sin_tocar == null || c.dias_sin_tocar <= DIAS_DORMIDA;
    });
    var dormidas = resto.filter(function (c) {
      return c.dias_sin_tocar != null && c.dias_sin_tocar > DIAS_DORMIDA;
    });

    var n = 1;
    if (vivas.length) {
      vivas.forEach(function (c) { listaEl.appendChild(pintarRenglon(c, n++)); });
      show(listaEl);
    }

    if (dormidas.length) {
      if (dormidasLabelEl) {
        dormidasLabelEl.textContent = plural(t('anteriores-one'), t('anteriores-other'), dormidas.length);
      }
      dormidas.forEach(function (c) { listaDormidasEl.appendChild(pintarRenglon(c, n++)); });
      show(dormidasEl);
    }
  }

  fetch(ENDPOINT, { method: 'GET', credentials: 'same-origin' })
    .then(function (r) { return r.json().catch(function () { return null; }); })
    .then(function (data) {
      // found:false sin código = sesión sin cliente resuelto. Se trata igual
      // que vacío: no hay nada que enseñar, y no es culpa de nadie.
      if (!data || data.error) {
        hide(loadingEl);
        show(errorEl);
        return;
      }
      render(data);
    })
    .catch(function () {
      hide(loadingEl);
      show(errorEl);
    });
})();
